// @flow

/**
 * config.js - файл конфигурации
 * @module config
 * */

export {routes} from './routes'
export const POLLING_INTERVAL = getPollingInterval()
export const APP_ROOT = global.location.pathname.replace(/\/$/, '')
export const dataProviderTypes: {
    ['string']: string
} = {
    LINKPULSE: 'linkpulse',
    YANDEX: 'yandex',
    MOCKUP: 'mockup',
}

function getPollingInterval(): number {
    return 30000
}



// WEBPACK FOOTER //
// ./src/config/index.js